const brand = {
    brand: "Oscar RC",
    name: "Oscar",
    lines: [
        "And I do web development",
        "Keep scrolling to know more"
    ]
}

export default brand;